import React, { FunctionComponent } from 'react';
import HvSvg from 'src/components/HvSvg';
import InProgressBG from './InProgress';
import {
  AlertIcon,
  HdBanner,
  FailedBG,
  ErrorMessage,
  EnhancedScreenshotImage,
  SpinnerBG,
} from './styled';

interface EnhancedScreenshotProps {
  imageUrl: string;
  isRenderingFailed: boolean;
  isRenderingComplete: boolean;
  isRenderingInProgress: boolean;
  isRenderingQueued: boolean;
  percentDone: number;
  showImage: () => {};
}

const EnhancedScreenshot: FunctionComponent<EnhancedScreenshotProps> = (
  props,
) => {
  const {
    imageUrl,
    percentDone,
    isRenderingComplete,
    isRenderingFailed,
    showImage,
    isRenderingInProgress,
    isRenderingQueued,
  } = props;

  const showHdBanner = !isRenderingFailed;

  return (
    <EnhancedScreenshotImage
      data-selenium="enhancedScreenshot"
      onClick={() => isRenderingComplete && showImage()}
      role="button"
      initial={false}
      layoutTransition={{
        type: 'spring',
        damping: 200,
        stiffness: 100,
      }}
      thumbnail={imageUrl}
      isRenderingComplete={isRenderingComplete}
    >
      {isRenderingQueued && (
        <SpinnerBG data-selenium="screenshotLoader">
          Please wait...
          <i className="fad fa-spinner-third fa-spin" />
        </SpinnerBG>
      )}
      {isRenderingInProgress && <InProgressBG percentDone={percentDone} />}
      {isRenderingFailed && (
        <FailedBG>
          <AlertIcon>
            <HvSvg src={require('src/assets/icons/error-logo.svg')} />
          </AlertIcon>
          <ErrorMessage>Error, try again.</ErrorMessage>
        </FailedBG>
      )}
      {showHdBanner && <HdBanner />}
    </EnhancedScreenshotImage>
  );
};

export default React.memo(EnhancedScreenshot);
